import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import BlogCard from '../components/BlogCard';
import { getArticles } from '../services/article';
import Loader from '../components/utils/Loader';
import Meta from '../components/Meta';
import NavPagination from '../components/NavPagination';
import { declOfNum } from '../helpers/all';
import SecPartners from '../components/SecPartners';
import { getPartner } from '../services/partner';
import { getImageURL } from '../helpers/all';
import { Link, useParams } from 'react-router-dom';

const Blog = () => {
  const { tagId } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState();
  const [articles, setArticles] = useState({
    loading: true,
    items: [],
  });
  const [partner, setPartner] = useState({
    loading: true,
    items: [],
  });
  const [currentTag, setCurrentTag] = useState(null);
  const onPageChange = (page) => {
    setCurrentPage(page.selected + 1);
    getPage(sort, page.selected + 1);
  };
  const getPage = useCallback((newSort, page, tag = tagId) => {
    const targetPage = page || 1; // Всегда сбрасываем на первую страницу при изменении тега
    let targetSort = sort;

    if (newSort || newSort === 0) {
      setSort(newSort);
      targetSort = newSort;
    }

    getArticles({
      sort: targetSort,
      page: targetPage,
      size: 24,
      tagId: tag // Добавляем tagId в запрос
    })
      .then((res) => {
        setArticles({
          loading: false,
          ...res,
        });
        setCurrentPage(res.pagination.currentPage);
        // Находим текущий тег, если есть tagId
        if (tagId && res.tags) {
          const activeTag = res.tags.find(t => t.uid === tagId);
          setCurrentTag(activeTag || null);
        }
      })
      .catch(() => setArticles(prev => ({ ...prev, loading: false })));
  }, [sort, tagId]);

  const handleTagClick = (tagUid) => {
    // При клике на тег сбрасываем страницу на первую
    setCurrentPage(1);
    // Сбрасываем сортировку
    setSort(undefined);
  };

  useEffect(() => {
    // При изменении tagId сбрасываем страницу на первую
    setCurrentPage(1);
    getPage(sort, 1, tagId);
  }, [tagId]);

  useEffect(() => {
    getPartner()
      .then(res => res && setPartner(prev => ({ ...prev, loading: false, ...res })))
      .catch(() => setPartner(prev => ({ ...prev, loading: false })));
  }, []);

  const declension = declOfNum(articles?.pagination?.totalItems, ['предложение', 'предложения', 'предложений']);

  if (articles.loading) return <Loader full />;

  return (
    <main>
      <Meta
        title={currentTag ? `${currentTag.title} - Новости и статьи` : "Бизнес новости и статьи"}
        description={currentTag ? `Статьи по тегу: ${currentTag.title}` : "Актуальные бизнес-новости, аналитика и советы"}
      />

      <Container>
        <section className='py-4 py-sm-5'>
          <h1 className='h2'>
            {currentTag ? `Тег: ${currentTag.title}` : 'Новости и статьи'}
          </h1>

          <nav className="catalog-nav mb-4">
            <NavPagination
              totalPages={articles?.pagination?.totalPages}
              onPageChange={onPageChange}
              currentPage={currentPage}
            />
            <p>
              {articles?.pagination?.totalItems <= 36
                ? `Показано ${articles.pagination.totalItems} ${declension}`
                : "Показано 24 предложения"}
            </p>
            <select
              value={sort || ''}
              onChange={(e) => getPage(e.target.value, 1)}
            >
              <option value="" disabled>Сортировать:</option>
              <option value="new">по дате: новые</option>
              <option value="old">по дате: ранние</option>
            </select>
          </nav>

          <Row>
            <Col lg={9}>
              <Row xs={1} sm={2} md={3} className="g-4">
                {articles?.items?.map((item) => (
                  <Col key={item.id}>
                    <BlogCard {...item} />
                  </Col>
                ))}
              </Row>
            </Col>

            <Col lg={3}>
              <div className="right-sidebar">
                <div className="tags-cloud">
                  <h5 className="tags-title">Новости по категориям</h5>
                  <div className="tags-list">
                    {articles.tags?.map(tag => (
                      <Link
                        key={tag.uid}
                        to={`/tag/${tag.uid}`}
                        className={`tag-link ${tagId === tag.uid ? 'active' : ''}`}
                        onClick={() => handleTagClick(tag.uid)}
                      >
                        {tag.title}
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="right-banners">
                  {articles.banners?.map(banner => (
                    <Link
                      key={banner.id}
                      to={banner.link}
                      target="_blank"
                      className="banner-card"
                    >
                      <img
                        src={getImageURL({
                          path: banner.media,
                          type: "banner",
                          size: ""
                        })}
                        alt={banner.title}
                        className="banner-img"
                      />
                      {banner.title && <h6 className="banner-title">{banner.title}</h6>}
                    </Link>
                  ))}
                </div>
              </div>
            </Col>
          </Row>

          <nav className="catalog-nav mt-4">
            <NavPagination totalPages={articles?.pagination?.totalPages} onPageChange={onPageChange} currentPage={currentPage} />
            {articles?.pagination?.totalItems <= 36 ? <p>Показано {articles?.pagination?.totalItems} {declension} из {articles?.pagination?.totalItems}</p>
              : <p>Показано 24 предложений из {articles?.pagination?.totalItems}</p>}
            <select defaultValue={false} value={sort} onChange={(e) => getPage(e.target.value, 1)}>
              <option value="false" disabled>Сортировать:</option>
              <option value="new">по дате публикации: новые</option>
              <option value="old">по дате публикации: ранние</option>
            </select>
          </nav>
        </section>
      </Container>

      <SecPartners partner={partner} />
    </main>
  );
};

export default Blog;